// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5480) return "static/chunks/5480.bafab46e1eac6610.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1786":"34e389fc676984e1","4689":"dec72a8e0464b847","9652":"ca06d6c8d33f46ba"}[chunkId] + ".js";
};